import { FileText, Send, TrendingDown, TrendingUp } from "lucide-react";
import React, { useEffect, useState } from "react";
// import { MetricCard } from "../../../Components/Dashboard/MetricCard"; // Unused import
import { LatestQuotations } from "../../../Components/Dashboard/LatestQuotations";
import { QuotationBreakdown } from "../../../Components/Dashboard/QuotationBreakdown";
import RevenuePieChart from "../../../Components/Dashboard/RevenuePieChart";
// import { Quotation } from "../../../Components/Dashboard/QuotationTable"; // Removed unused import
import { Typography } from "@mui/material";
import { app_modules } from "helpers/apps_modules_list";
import { Col, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchLatestPermissions } from "slices/auth/login/thunk";
import { fetchDashboardData, setFilters } from "slices/dashboard";
import { RootState } from "slices/index";
import DashboardFilters from "../../../Components/Dashboard/DashboardFilters";
import { DetailedListingSheet } from "../../../Components/Dashboard/DetailedListingSheet";
import LoaderErrorWrapper from "../../../Components/LoaderErrorWrapper/LoaderErrorWrapper";

export default function Ecommerce() {
  document.title = "Dashboard | Quotations Management";
  const [sheetType, setSheetType] = useState<
    "total" | "sent" | "won" | "lost" | null
  >(null);
  // const [showWelcome, setShowWelcome] = useState(true);
  const [dashboardFilters, setDashboardFilters] = useState({
    timePeriod: "Today",
    dateRange: { from: "", to: "" },
    createdBy: "",
  });

  // User Permissions
  const user = useSelector((state: any) => state.Login.user);
  const user_permissions = user?.permissions || [];
  const master_permissions = user_permissions?.find(
    (item: any) => item?.apps_name === app_modules?.dashboard?.app_name
  );
  const dashboard_permissions = master_permissions?.modules_permissions?.find(
    (item: any) =>
      item?.modules_name === app_modules?.dashboard?.modules?.dashboard
  );

  const dispatch = useDispatch<any>();

  // Redux state
  const {
    data: dashboardData,
    loading,
    error,
  } = useSelector((state: RootState) => state.DashboardReducer);

  // Permissions
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        await dispatch(fetchLatestPermissions()).unwrap();
      } catch (error) {
        console.error("Failed to fetch latest permissions", error);
        // toast.error("Failed to fetch latest permissions");
      }
    };
    fetchPermissions();
  }, [dispatch]);

  // Fetch dashboard data on component mount and when filters change
  useEffect(() => {
    const fetchData = async () => {
      try {
        const filters = {
          created_at_from: dashboardFilters.dateRange.from || undefined,
          created_at_to: dashboardFilters.dateRange.to || undefined,
          user_id: dashboardFilters.createdBy || undefined,
        };

        console.log("Raw filters before cleaning:", filters);
        console.log("dashboardFilters.createdBy:", dashboardFilters.createdBy);

        // Remove undefined values
        const cleanFilters = Object.fromEntries(
          Object.entries(filters).filter(([_, value]) => value !== undefined)
        );

        console.log("Clean filters being sent to API:", cleanFilters);

        if (Object.keys(cleanFilters).length === 0) {
          return;
        }

        await dispatch(fetchDashboardData(cleanFilters)).unwrap();
      } catch (error) {
        console.error("Failed to fetch dashboard data", error);
      }
    };

    fetchData();
  }, [dispatch, dashboardFilters]);

  // Get data from API or fallback to mock data
  const totalQuotations = dashboardData?.summary?.Total_Quotation || 0;
  const sentQuotations = dashboardData?.summary?.given_sort_count || 0;
  const wonQuotations = dashboardData?.summary?.Won_count || 0;
  const lostQuotations = dashboardData?.summary?.Lost_count || 0;

  // Revenue data
  const summary = dashboardData?.summary as any;
  const totalRevenue = summary?.Total_Quotation_Revenue || 0;
  const sentRevenue = summary?.Given_Sort_Revenue || 0;
  const wonRevenue = summary?.Won_Revenue || 0;
  const lostRevenue = summary?.Lost_Revenue || 0;

  // useEffect(() => {
  //   if (showWelcome) {
  //     console.log(
  //       "Welcome to QuoteFlow Dashboard! Click on any metric card to view detailed listings"
  //     );
  //     setShowWelcome(false);
  //   }
  // }, [showWelcome]);

  const handleMetricClick = (type: "total" | "sent" | "won" | "lost") => {
    setSheetType(type);
    console.log(`Opening ${type} quotations listing`);
  };

  const handleFiltersChange = (filters: {
    timePeriod: string;
    dateRange: { from: string; to: string };
    createdBy: string;
  }) => {
    console.log("Dashboard received filters:", filters);
    setDashboardFilters(filters);
    dispatch(setFilters(filters));
    console.log("Dashboard filters updated:", filters);
  };

  // Handle user inactive error specifically
  const isUserInactiveError = error === "User inactive or deleted";


  return (
    <React.Fragment>
      {!dashboard_permissions?.permissions?.View ? (
        <>
          {/* Fallback If user is not Admin or not authenticated */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            <Typography variant="h5">
              Welcome to the ABGB Quotation Management Dashboard.
            </Typography>
            {!user && (
              <Typography variant="body1" color="textSecondary">
                Please log in to access the dashboard.
              </Typography>
            )}
          </div>
        </>
      ) : (
        <div className="container-fluid page-content">
          {/* Error Handling with LoaderErrorWrapper */}
          <LoaderErrorWrapper 
            loading={false} 
            error={isUserInactiveError ? "Your account has been deactivated. Please contact your administrator." : error}
          >
            {/* Header */}
          {/* <div className="row mb-4">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="mb-1">Dashboard Overview</h4>
                  <p className="text-muted mb-0">
                    Welcome back! Here's what's happening with your quotations.
                  </p>
                </div>
                <div className="d-flex gap-3 align-items-center">
            
                  <Button
                    variant="primary"
                    onClick={() => navigate("/add-quotation")}
                    style={{ minWidth: "150px" }}
                    disabled={loading}
                  >
                    <Plus size={18} className="me-2" />
                    New Quotation
                  </Button>
                </div>
              </div>
            </div>
          </div> */}

          {/* Dashboard Filters */}
          <DashboardFilters onFiltersChange={handleFiltersChange} />

          {/* Metrics Cards */}
          <Row className="mb-4 g-4">
            {/* Total Quotations */}
            <Col xl={3} md={6} sm={12}>
              <div
                className="dashboard-metric-card h-100 shadow-lg rounded-4 position-relative overflow-hidden border-0"
                style={{
                  background:
                    // "linear-gradient(120deg, #4481eb 0%, #04befe 100%)",
                    "linear-gradient(120deg, #005D97 0%, #04befe 100%)",
                  minHeight: 80,
                  cursor: "pointer",
                  transition: "box-shadow 0.2s, transform 0.2s",
                  boxShadow: "0 8px 24px rgba(60, 132, 252, 0.20)",
                }}
                onClick={() => handleMetricClick("total")}
              >
                <div className="p-3 d-flex flex-column h-100 justify-content-between">
                  <div className="d-flex align-items-center mb-2 gap-2">
                    <span
                      className="metric-icon rounded-circle bg-white d-flex align-items-center justify-content-center shadow-sm"
                      style={{ width: 40, height: 40 }}
                    >
                      <FileText size={24} className="text-primary" />
                    </span>
                    <span className="fw-bold fs-6 text-white">
                      Total Quotations
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <span
                      className="fs-2 fw-bold text-white"
                      style={{ letterSpacing: 1 }}
                    >
                      {loading ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                      ) : (
                        totalQuotations
                      )}
                    </span>
                    {!loading && (
                      <span className="fs-5 text-white opacity-90">
                        ₹{" "}
                        {Number(totalRevenue || 0).toLocaleString("en-IN", {
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </Col>
            {/* Quotations Sent */}
            <Col xl={3} md={6} sm={12}>
              <div
                className="dashboard-metric-card h-100 shadow-lg rounded-4 position-relative overflow-hidden border-0"
                style={{
                  background:
                    "linear-gradient(120deg,rgb(199, 106, 0) 0%,rgb(255, 195, 85) 100%)",
                  minHeight: 80,
                  cursor: "pointer",
                  transition: "box-shadow 0.2s, transform 0.2s",
                  boxShadow: "0 8px 24px rgba(145, 86, 239, 0.13)",
                }}
                onClick={() => handleMetricClick("sent")}
              >
                <div className="p-3 d-flex flex-column h-100 justify-content-between">
                  <div className="d-flex align-items-center mb-2 gap-2">
                    <span
                      className="metric-icon rounded-circle bg-white d-flex align-items-center justify-content-center shadow-sm"
                      style={{ width: 40, height: 40 }}
                    >
                      <Send size={24} className="text-warning" />
                    </span>
                    <span className="fw-bold fs-6 text-white">
                      Quotations Sent
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <span
                      className="fs-2 fw-bold text-white"
                      style={{ letterSpacing: 1 }}
                    >
                      {loading ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                      ) : (
                        sentQuotations
                      )}
                    </span>
                    {!loading && (
                      <span className="fs-5 text-white opacity-90">
                        ₹{" "}
                        {Number(sentRevenue || 0).toLocaleString("en-IN", {
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </Col>
            {/* Won Quotations */}
            <Col xl={3} md={6} sm={12}>
              <div
                className="dashboard-metric-card h-100 shadow-lg rounded-4 position-relative overflow-hidden border-0"
                style={{
                  background:
                    // "linear-gradient(120deg,rgb(2, 219, 45) 0%, rgb(23, 231, 92) 100%)",
                    "linear-gradient(120deg,rgb(4, 180, 39) 0%, rgb(23, 231, 92) 100%)",
                  minHeight: 80,
                  cursor: "pointer",
                  transition: "box-shadow 0.2s, transform 0.2s",
                  boxShadow: "0 8px 24px rgba(50, 201, 122, 0.14)",
                }}
                onClick={() => handleMetricClick("won")}
              >
                <div className="p-3 d-flex flex-column h-100 justify-content-between">
                  <div className="d-flex align-items-center mb-2 gap-2">
                    <span
                      className="metric-icon rounded-circle bg-white d-flex align-items-center justify-content-center shadow-sm"
                      style={{ width: 40, height: 40 }}
                    >
                      <TrendingUp size={24} className="text-success" />
                    </span>
                    <span className="fw-bold fs-6 text-white">
                      Won Quotations
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <span
                      className="fs-2 fw-bold text-white"
                      style={{ letterSpacing: 1 }}
                    >
                      {loading ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                      ) : (
                        wonQuotations
                      )}
                    </span>
                    {!loading && (
                      <span className="fs-5 text-white opacity-90">
                        ₹{" "}
                        {Number(wonRevenue || 0).toLocaleString("en-IN", {
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </Col>
            {/* Lost Quotations */}
            <Col xl={3} md={6} sm={12}>
              <div
                className="dashboard-metric-card h-100 shadow-lg rounded-4 position-relative overflow-hidden border-0"
                style={{
                  background:
                    "linear-gradient(120deg, #fd5e53 0%, #ff7e5f 100%)",
                  minHeight: 80,
                  cursor: "pointer",
                  transition: "box-shadow 0.2s, transform 0.2s",
                  boxShadow: "0 8px 24px rgba(253, 94, 83, 0.13)",
                }}
                onClick={() => handleMetricClick("lost")}
              >
                <div className="p-3 d-flex flex-column h-100 justify-content-between">
                  <div className="d-flex align-items-center mb-2 gap-2">
                    <span
                      className="metric-icon rounded-circle bg-white d-flex align-items-center justify-content-center shadow-sm"
                      style={{ width: 40, height: 40 }}
                    >
                      <TrendingDown size={24} className="text-danger" />
                    </span>
                    <span className="fw-bold fs-6 text-white">
                      Lost Quotations
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <span
                      className="fs-2 fw-bold text-white"
                      style={{ letterSpacing: 1 }}
                    >
                      {loading ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                      ) : (
                        lostQuotations
                      )}
                    </span>
                    {!loading && (
                      <span className="fs-5 text-white opacity-90">
                        ₹{" "}
                        {Number(lostRevenue || 0).toLocaleString("en-IN", {
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* Loading State */}
          {loading && (
            <Row className="mb-4">
              <Col className="text-center">
                <div className="d-flex align-items-center justify-content-center gap-3">
                  <Spinner animation="border" variant="primary" size="sm" />
                  <span className="text-muted">Loading dashboard data...</span>
                </div>
              </Col>
            </Row>
          )}

          {/* Revenue Pie Chart and Quotation Breakdown - Single Row */}
          {!loading && (
            <Row className="mb-4">
              <Col xl={4}>
                <RevenuePieChart
                  data={
                    dashboardData
                      ? { summary: dashboardData.summary as any }
                      : undefined
                  }
                />
              </Col>
              <Col xl={8}>
                <QuotationBreakdown data={dashboardData} />
              </Col>
            </Row>
          )}

          {/* Latest Quotations */}
          {!loading && (
            <Row className="mb-4">
              <Col xl={12}>
                <LatestQuotations />
              </Col>
            </Row>
          )}
          </LoaderErrorWrapper>
        </div>
      )}

      {/* Detailed Listing Sheet */}
      <DetailedListingSheet
        open={sheetType !== null}
        onClose={() => setSheetType(null)}
        type={sheetType || "total"}
        dashboardFilters={dashboardFilters}
      />
    </React.Fragment>
  );
}
